(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () {
    var menu = document.querySelector('[data-postal-menu]');

    if (menu && !menu.hasAttribute('data-postal-menu-bound')) {
      menu.setAttribute('data-postal-menu-bound', 'true');

      var summary = menu.querySelector('summary');
      var panel = menu.querySelector('.sp-mobile-menu');
      var closeButton = panel ? panel.querySelector('[data-postal-menu-close]') : null;
      var firstSearch = panel ? panel.querySelector('input[type="search"]') : null;
      var backdrop = document.createElement('button');
      var closeTimer = null;
      var lastFocused = null;

      backdrop.type = 'button';
      backdrop.className = 'sp-mobile-menu-backdrop';
      backdrop.setAttribute('aria-label', 'Close store menu');
      backdrop.hidden = true;

      if (panel) {
        panel.id = panel.id || 'PostalMobileMenu';
        panel.setAttribute('aria-hidden', 'true');
        panel.hidden = true;
        document.body.appendChild(backdrop);
        document.body.appendChild(panel);
      }

      if (summary && panel) {
        summary.setAttribute('aria-controls', panel.id);
        summary.setAttribute('aria-expanded', 'false');
      }

      function focusableItems() {
        if (!panel) return [];
        return Array.prototype.slice.call(panel.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
        )).filter(function (item) {
          return item.offsetParent !== null;
        });
      }

      function showPanel() {
        if (!panel) return;

        window.clearTimeout(closeTimer);
        lastFocused = document.activeElement;
        panel.hidden = false;
        backdrop.hidden = false;
        panel.setAttribute('aria-hidden', 'false');
        document.body.classList.add('sp-menu-open');

        if (summary) {
          summary.setAttribute('aria-expanded', 'true');
          summary.setAttribute('aria-label', 'Close store menu');
        }

        window.requestAnimationFrame(function () {
          panel.classList.add('is-open');
          backdrop.classList.add('is-open');
        });

        window.setTimeout(function () {
          if (firstSearch && menu.open) {
            firstSearch.focus({ preventScroll: true });
          } else if (closeButton && menu.open) {
            closeButton.focus({ preventScroll: true });
          }
        }, 230);
      }

      function hidePanel(restoreFocus) {
        if (!panel) return;

        panel.classList.remove('is-open');
        backdrop.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('sp-menu-open');

        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
          summary.setAttribute('aria-label', 'Open store menu');
        }

        closeTimer = window.setTimeout(function () {
          if (!menu.open) {
            panel.hidden = true;
            backdrop.hidden = true;
          }
        }, 320);

        if (restoreFocus) {
          window.setTimeout(function () {
            if (summary) {
              summary.focus({ preventScroll: true });
            } else if (lastFocused && typeof lastFocused.focus === 'function') {
              lastFocused.focus({ preventScroll: true });
            }
          }, 40);
        }

        panel.querySelectorAll('.sp-mobile-submenu[open]').forEach(function (submenu) {
          submenu.open = false;
        });
      }

      function closeMenu(restoreFocus) {
        if (!menu.open) {
          hidePanel(restoreFocus);
          return;
        }
        menu.open = false;
        hidePanel(restoreFocus);
      }

      menu.addEventListener('toggle', function () {
        if (menu.open) {
          showPanel();
        } else {
          hidePanel(false);
        }
      });

      if (closeButton) {
        closeButton.addEventListener('click', function () {
          closeMenu(true);
        });
      }

      backdrop.addEventListener('click', function () {
        closeMenu(true);
      });

      if (panel) {
        panel.querySelectorAll('a').forEach(function (link) {
          link.addEventListener('click', function () {
            closeMenu(false);
          });
        });
      }

      document.addEventListener('keydown', function (event) {
        if (!menu.open || !panel) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          closeMenu(true);
          return;
        }

        if (event.key !== 'Tab') return;

        var items = focusableItems();
        if (!items.length) return;

        var first = items[0];
        var last = items[items.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      window.addEventListener('resize', function () {
        if (window.innerWidth > 1040 && menu.open) {
          closeMenu(false);
        }
      }, { passive: true });
    }

    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var revealItems = Array.prototype.slice.call(
      document.querySelectorAll('[data-sp-reveal]')
    );

    revealItems.forEach(function (item) {
      var delay = parseInt(item.getAttribute('data-delay') || '0', 10);
      item.style.setProperty('--sp-delay', Math.max(0, delay) + 'ms');
      item.classList.add('sp-motion-ready');
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
    } else {
      var observer = new IntersectionObserver(function (entries, activeObserver) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          activeObserver.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.08
      });

      revealItems.forEach(function (item) {
        observer.observe(item);
      });
    }

    document.querySelectorAll('[data-postal-search-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        var input = form.querySelector('input[type="search"]');
        var label = form.querySelector('.sp-search-form__button-label');

        if (!input || !input.value.trim()) {
          event.preventDefault();
          if (input) input.focus();
          return;
        }

        form.classList.add('is-searching');
        if (label) label.textContent = 'Searching…';
      });
    });

    document.querySelectorAll('.sp-conversion-mailer__form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var email = form.querySelector('input[type="email"]');
        var button = form.querySelector('[data-newsletter-submit] span');

        if (!email || !email.checkValidity()) return;
        if (button) button.textContent = 'Joining…';
      });
    });
  });
})();
